import enums from "../utils/enums";
import {
  checkMetadataControlValue,
  createViewMetaData,
  createComponentMetaData,
  validateCaption,
  // createPinyinField,
  setCtrlMetadataFullCode
} from "./designerMetadataHelper";

let postForm = ["form", "question", "exam"];
//保存布局是被排除的属性
let layoutExclude = ["layoutRoot", "layoutParent", "isDesign", "$vm", "local"];

function loader() {
  return import(/*webpackChunkName:"core_designer_async"*/ "./~designer");
}

function getParentControl(el) {
  let target = $(el);
  let slotEl = $(target).closest("[slot-name]");
  let container = null;

  let mark = false;
  //判断插槽元素是否本身就是一个组件且不是一个被镶嵌在其他组件内部
  if (slotEl.hasClass("ds-control")) {
    let vueComponent = slotEl.get(0).__vue__;
    container = vueComponent;
    if (container.$$getComponent) {
      container = container.$$getComponent();
    }
  } else {
    mark = true;
  }
  if (mark) {
    container = slotEl.parents(".ds-control");
    if (container.get(0)) {
      let vueComponent = container.get(0).__vue__;
      container = vueComponent;
    }
  }
  if (container) {
    let layoutContainer = container;
    let layoutParent = layoutContainer.$layoutTree;
    // let ctrlType = layoutContainer.ctrlType;
    while (!layoutParent) {
      layoutContainer = layoutContainer.$parent;
      layoutParent = layoutContainer.$layoutTree;
    }
    if (layoutParent) {
      return layoutParent;
    }
  }
  // //插糟是个普通的html元素
  // else {
  //   mark = true;
  // }
  // if (mark) {
  //   container = slotEl.parents(".ds-control");
  //   if(container.get(0)){
  //     let vueComponent = container.get(0).__vue__;
  //     if(vueComponent){
  //       let layoutParent=vueComponent.$layoutParent;
  //       if(layoutParent){
  //         container=layoutParent.$$getComponent()
  //       }
  //     }
  //   }
  // } else {
  //   container = slotEl;
  // }
  // return container;
}

function getDsfComponent(comp, maxComponent) {
  let vueComponent = comp;
  if (vueComponent) {
    //如果组件不是按我们系统规范创建的组件则继续向上查找
    if (vueComponent.$$getComponent) {
      vueComponent = vueComponent.$$getComponent();
    }
    while (!vueComponent.$props.isDsf || !vueComponent.$props.ctrlName) {
      vueComponent = vueComponent.$parent;
      if (vueComponent.$$getComponent) {
        vueComponent = vueComponent.$$getComponent();
      }
      if (vueComponent.$el == maxComponent.$el) {
        vueComponent = null;
        break;
      }
    }
  }
  return vueComponent;
}

function createComponent(name, attrs, isSilent) {
  let comp = dsf.createComponent(name, attrs);
  if (!comp) {
    isSilent !== true && dsf.layer.message(`【${name}】组件在当前客户端尚未被支持`, false);
    return null;
  }
  if (!comp.designId) {
    comp.designId = dsf.uuid();
  }
  return comp;
}

function createMobileComponent(name, attrs, isSilent) {
  name = getComponentCodeByClient(name, true);
  let comp = dsf.createComponent(name, attrs, isSilent);
  if (!comp) {
    isSilent !== true && dsf.layer.message(`【${name}】组件在当前客户端尚未被支持`, false);
    return null;
  }
  if (!comp.designId) {
    comp.designId = dsf.uuid();
  }
  return comp;
}
//根据不同客户端获取组件代码
function getComponentCodeByClient(code, isMobile) {
  if (dsf.type(code) != "string") {
    return code;
  }
  if (!isMobile) {
    return code.replace('dsf.mobile.', 'dsf.');
  }
  let arr = code.split(".");
  if (arr[1] != "mobile") {
    arr.splice(1, 0, "mobile");
    return arr.join(".");
  }
  return code;
}

//获取触发事件的组件
function getComponentByTarget(target) {
  target = $(target);
  target = target.closest(".designer-ctrl-proxy");
  let component = target.get(0).__vue__;
  if (component) {
    component = component.$$getComponent ? component.$$getComponent() : component;
    return component;
  }
  return null;
}

function getRealComponent(target) {
  target = target.jquery ? target.get(0) : target;
  if (target.__vue__) {
    let com = target.__vue__;
    if (com.$$getComponent) {
      com = com.$$getComponent();
    }
    return com;
  }
  return null;
}

//是否允许拖放
function isAllowDrop(target, maxComponent) {
  let curr = null,
    count = 0,
    allow = true;
  if (!target) {
    return false;
  }
  if (target.jquery) {
    curr = target.length > 0 ? target.get(0) : null;
  } else {
    curr = target;
  }
  if (!curr) {
    return false;
  }
  //如果标记上存在disabled-drop样式则不允许拖动
  if (curr.matches(".disabled-drop") || curr.matches(".freeze-slot")) {
    return false;
  }
  do {
    if (curr == maxComponent.$el) {
      break;
    }
    if (curr.__vue__) {
      let vueComponent = getDsfComponent(curr.__vue__, maxComponent);
      if (vueComponent && !vueComponent.$props.isDesign) {
        allow = false;
        break;
      } else {
        break;
      }
    } else {
      curr = curr.parentNode;
    }
    count++;
  } while (count < 100);
  return allow;
}

//将组件转化为json
function controlToJson(ctrl, callback) {
  if (callback) {
    JSON.stringify(ctrl, callback);
  }
  return JSON.stringify(ctrl);
}

//向下传播设计器事件
function broadcast(sourceComponent, eventName, evt, params, excludeComponent) {
  sourceComponent.$children.forEach((child) => {
    if (child.$options.design && child.$options.design[eventName]) {
      if (excludeComponent != child) {
        child.$options.design[eventName].call(child, evt, params);
      }
    }
    broadcast(child, eventName, evt, params, excludeComponent);
  });
}

function getLayoutInfo(page, isPreView, isFullProps = true) {
  let arrs = [];
  let root = null;
  let currentSlots = {};
  let temp = [];
  let popFn = () => {
    arrs.pop();
  };
  recursionLayoutTree(
    page,
    null,
    null,
    (component, parent, slotName) => {
      let parentProps = arrs[arrs.length - 1];
      let designOptions = component.$options ? component.$options.design : null;
      if (designOptions) {
        let layoutNode = designOptions.layout || {};
        layoutNode.before && layoutNode.before.call(component);
      }
      let slotProps = component.$props.slots;
      if (parent) {
        currentSlots[parent.designId] = slotName;
      }
      // delete component.$props.slots;
      let copyPorps = {};
      for (let k in component.$props) {
        if (k != "slots") {
          copyPorps[k] = component.$props[k];
        }
      }
      let props = dsf.mix(true, {}, copyPorps);
      props.slots = _.map(slotProps, (it) => {
        let s = {};
        for (let k in it) {
          if (k != "controls") {
            s[k] = it[k];
          }
        }
        s.controls = [];
        return s;
      });
      if (component.$attrs["slot-name"]) {
        props["slot-name"] = component.$attrs["slot-name"];
      }
      Object.defineProperty(props, "$slotsMap", {
        value: _.keyBy(props.slots, "name"),
        enumerable: false,
        configurable: true
      });
      let excludeProps = [...layoutExclude];
      let includeProps = [];
      let unnecessaryProps = [];
      if (component.$options && component.$options.design) {
        let layout = component.$options.design.layout;
        if (layout) {
          let r = getDesignLayoutIncludeAndExclude(component.$options) || [];
          let exclude = r.exclude;
          let include = r.include;
          let unnecessary = r.unnecessary;
          excludeProps = excludeProps.concat(exclude);
          includeProps = includeProps.concat(include);
          unnecessaryProps = unnecessaryProps.concat(unnecessary);
        }
      }
      let componentProps = null;
      if (!isFullProps) {
        componentProps = dsf.createComponent(props.ctrlType);
      }
      for (let propKey in props) {
        if (includeProps.includes(propKey)) {
          continue;
        }
        if (excludeProps.length) {
          if (isPreView) {
            //预览模式下如果属性前带有#，则保留，否则删除
            if (excludeProps.includes(propKey)) {
              delete props[propKey];
            }
          } else {
            let propKey2 = "#" + propKey;
            if (excludeProps.includes(propKey2) || excludeProps.includes(propKey)) {
              delete props[propKey];
            }
          }
        }
        if (!isFullProps && unnecessaryProps.length) {
          //获取组件默认属性
          if (unnecessaryProps.includes(propKey)) {
            //如果组件当前值与默认值相同，则存入
            let v1 = componentProps[propKey];
            let v2 = props[propKey];
            let isRefType =
              dsf.isObject(v1) || // 判断v1是否为对象
              dsf.isObject(v2) || // 判断v2是否为对象
              dsf.isArray(v1) || // 判断v1是否为数组
              dsf.isArray(v2) || // 判断v2是否为数组
              dsf.isFunction(v1) || // 判断v1是否为函数
              dsf.isFunction(v2); // 判断v2是否为函数
            if (isRefType && JSON.stringify(v1) === JSON.stringify(v2)) {
              delete props[propKey]; // 如果isRefType为true且v1和v2的JSON字符串相等，则删除props的propKey属性
            } else if (v1 === v2) {
              delete props[propKey]; // 如果v1和v2相等，则删除props的propKey属性
            }
          }
        }
      }
      arrs.push(props);

      if (!parentProps) {
        root = props;
      }
      let slots = props.slots;
      _.each(slots, (slot) => {
        slot.controls = [];
      });
      if (parentProps) {
        let slot = parentProps.$slotsMap[slotName];
        // let slot = _.find(parentProps.slots, s => s.name == slotName);
        if (slot) {
          slot.controls.push(props);
        }
      }
    },
    popFn
  );
  return root;
}

//获取当前组件的design中layout的数据
function getDesignLayoutIncludeAndExclude(options) {
  if (options && options.design && options.design.layout) {
    let result = {
      include: [],
      exclude: [],
      unnecessary: []
    };
    if (options.extends) {
      let extendsResult = getDesignLayoutIncludeAndExclude(options.extends);
      for (let k in extendsResult) {
        result[k] = result[k].concat(extendsResult[k] || []);
      }
    }
    if (options.mixins) {
      for (let i = 0; i < options.mixins.length; i++) {
        if (!options.mixins[i]) {
          continue;
        }
        let mixinsResult = getDesignLayoutIncludeAndExclude(options.mixins[i]);
        for (let k in mixinsResult) {
          result[k] = result[k].concat(mixinsResult[k] || []);
        }
      }
    }
    if (options.design.layout.include) {
      result.include = result.include.concat(options.design.layout.include);
    }
    if (options.design.layout.exclude) {
      result.exclude = result.exclude.concat(options.design.layout.exclude);
    }
    if (options.design.layout.unnecessary) {
      result.unnecessary = result.unnecessary.concat(options.design.layout.unnecessary);
    }
    for (let k in result) {
      result[k] = _.uniq(result[k]);
    }
    return result;
  }
  return null;
}

//获取页面配置的所有静态数据
function getStaticValue(page) {
  // console.time("搜集页面使用的静态数据");
  let staticValue = {};
  recursionLayoutTree(page, null, null, (component, parent, slotName) => {
    if (component.staticValue && component.caption) {
      staticValue[component.caption] = component.staticValue;
    }
  });
  // console.timeEnd("搜集页面使用的静态数据");
  return staticValue;
}

function getDoc(designer) {
  return designer.pageDocument;
}
//解析页面
function analysisLayoutInfo(res) {
  let layout = null,
    showLogic = null,
    scss = null,
    staticValue = null,
    doc = null,
    designer = null;
  let dom = $("<div>" + res.data + "</div>");
  let layoutStr = dom.children("script[id='layout']").html() || "";
  let scssStr = dom.children("script[id='scss']").html() || "";
  let showLogicStr = dom.children("script[id='showLogic']").html() || ""; //显示逻辑配置
  let designerStr = dom.children("script[id='designer']").html() || "";
  let staticValueStr = dom.children("script[id='staticValue']").html() || "";
  let docStr = dom.children("script[id='doc']").html() || "";
  // let onlineStr = dom.children("script[id='onLineComponents']").html() || "";
  let layoutFn = new Function(
    ["var layout=" + (layoutStr || "null") + ";", "return layout;"].join("\n")
  );
  let scssFn = new Function(["return " + JSON.stringify(scssStr.trim() || "")].join("\n"));
  let showLogicFn = new Function(["return " + (showLogicStr.trim() || "{}")].join("\n"));
  let designerFn = new Function(["return " + (designerStr.trim() || "{}").trim()].join("\n"));
  let staticValueFn = new Function(["return " + (staticValueStr.trim() || "{}").trim()].join("\n"));
  let docFn = new Function(
    ["return " + JSON.stringify(dsf.unescapeHTML(docStr) || "").trim()].join("\n")
  );
  let layoutObj = layoutFn();
  var returnValue = {
    layout: layoutObj,
    staticValue: staticValueFn(),
    scss: scssFn(),
    showLogic: showLogicFn(),
    designer: designerFn(),
    doc: docFn()
  };

  return requestAsyncComponentsByLayout(layoutObj).then(() => returnValue);
}
//解析layout布局
function requestAsyncComponentsByLayout(layout, callback) {
  let asyncComList = [];
  dsf.recursionComponentProps(layout, (prop) => {
    let asyncCom = dsf.checkAsyncComponent(prop.ctrlName);
    let mark = true;
    if (asyncCom && callback) {
      //如果callback返回false则不加载该异步组件
      let _cbres = callback(prop);
      mark = _cbres === false ? false : true;
    }
    if (mark !== false && asyncCom && !asyncComList.includes(asyncCom)) {
      asyncComList.push(asyncCom);
    }
  });
  if (asyncComList.length) {
    return dsf.requestAsyncComponents(asyncComList).then(() => {
      return Promise.resolve();
    });
  } else {
    return Promise.resolve();
  }
}

//递归组件
function recursionLayoutTree(component, parent, slotName, callback, callbackAfter) {
  if (component) {
    while (!component.$$getComponent) {
      component = component.$parent;
    }
    if (!component) {
      return;
    }
    component = component.$$getComponent();
    let isContinue;
    if (callback) {
      isContinue = callback(component, parent, slotName);
    }
    if (isContinue !== false) {
      let designMethods = component.$options.design;
      let layoutNode = designMethods.layout;
      let isdeep = dsf.isFunction(layoutNode.isDeep)
        ? layoutNode.isDeep.call(component)
        : layoutNode.isDeep;
      if (isdeep !== false) {
        for (let i = 0; i < component.slots.length; i++) {
          let slot = component.slots[i];
          for (let n = 0; n < slot.controls.length; n++) {
            let control = slot.controls[n];
            let target = control.__layoutTree__;
            if (!target) {
              let desid = control.designId;
              target = component.$designer.allComponents[desid];
              if (!target) {
                target = $("[des-id='" + desid + "']");
                target = target?.get?.(0)?.__vue__ || null;
              }
            }
            recursionLayoutTree(target, component, slot.name, callback, callbackAfter);
            //使用函数式组件代理真实组件的情况，统计云报表设计器使用该方式
            // if (control.__virtual__) {
            //   recursionLayoutTree(control.__layoutTree__, component, slot.name, callback, callbackAfter);
            // } else {
            //   let target = component.$designer.allComponents[desid];
            //   if (!target) {
            //     target = $("[des-id='" + desid + "']");
            //     target = target?.get?.(0)?.__vue__ || null;
            //   }
            //   if (target) {
            //     recursionLayoutTree(target, component, slot.name, callback, callbackAfter);
            //   }
            // }
          }
        }
      }
    }
    callbackAfter && callbackAfter(component, parent, slotName);
  }
}

//保存布局时验证
function saveLayoutValidate(page) {
  let errors = [];
  // console.time("保存前校验");
  recursionLayoutTree(page, null, null, (el, parent, slotName) => {
    if (el.isFormControl) {
      let layout = el.$options.design ? el.$options.design.layout : {};
      let nameValidate = true;
      if (dsf.hasOwn(layout, "nameValidate") && layout.nameValidate === false) {
        nameValidate = false;
      }
      if (isPrototypePage(page)) {
        nameValidate = false;
      }
      if (nameValidate) {
        //验证表单组件的标识不能等于自己组件的名字开头，避免提交时数据库生成无意义的字段和表
        _.each(validateCaption(el), (error) => {
          errors.push(error);
        });
      }
      // 编号控件必须设置编号规则
      if ((el.ctrlType == "dsf.numeration" || el.ctrlType == "dsf.mobile.numeration") && !el.rule) {
        errors.push("请为" + el.caption + "设置编号规则");
      }
    }
  });
  // console.timeEnd("保存前校验");
  if (errors.length) {
    dsf.layer.pc.message(errors[0], false);
    return false;
  }
}

//获取extjs路径
function getExtPath(b, m, pn, isMobile, isTpl) {
  let tplOrViews = isTpl ? "tpl" : "views";
  let folder = [b, m].join(".");
  let clientDirs = isMobile ? "mobile/" + tplOrViews : "pc/" + tplOrViews;
  let extPath = `${clientDirs}/${folder}/${pn}.ext.js`;
  return extPath;
}

function getPageDocumet(b, m, pn, isMobile) {
  let folder = [b, m].join(".");
  let clientDirs = isMobile ? "mobile/views" : "pc/views";
  let docPath = `${clientDirs}/${folder}/${pn}.doc.html`;
  return docPath;
}

//获取layout文件路径
function getLayoutPath(b, m, pn, isMobile, isTpl) {
  let tplOrViews = isTpl ? "temp" : "views";
  let folder = [b, m].join(".");
  // let clientDirs = isMobile ? dsf.url.getWebPath("/mobile/" + tplOrViews) : dsf.url.getWebPath("/pc/" + tplOrViews);
  let clientDirs = isMobile ? "mobile/" + tplOrViews : "pc/" + tplOrViews;
  let htmlPath = `${clientDirs}/${folder}/${pn}.layout.html`;
  return htmlPath;
}

// let innerControls = ['DsfCol', 'DsfTableRow', 'DsfTableCell'];

//转化vue模板
function convertTemplateAndControlData(layout, hasComment, isPreView = false, hasExtJs = true) {
  let showLogicOptions = layout.showLogic;
  let showLogicCompile = layout.showLogicCompile;
  layout = dsf.mix(true, {}, layout);
  let defaultOptions = {
    before: null,
    after: null
  };
  // dsf.mix(defaultOptions, options);
  let parentNodes = [];
  /**
   * @param node 当前布局组建的props
   * @param parent 夫组件的props
   * @param slot 当前组件所在的插槽信息
   * @param slotScope 所在作用域插槽的参数名
   * @param scopeDataKey
   * @param isRepeat 是否在一个表格循环内
   * @param prefix 循环表格组件的caption前缀（暂时无用）
   * @param textProxy 遇到表单组件时是否显示一个<span>代理组件的输出（数据列表中使用，避免列表加载数据时每行都要实例化组件）
   * @returns {{tpl: *[], props: {}}}
   */
  function createElement(node, parent, slot, slotScope, scopeDataKey, isRepeat, prefix, textProxy) {
    let arr = [],
      props = {},
      controlHash = "";
    defaultOptions.before &&
      defaultOptions.before(node, parentNodes, slot, slotScope, scopeDataKey);
    node && parentNodes.push(node);
    const isFormControl = node.isFormControl;
    const isHTMLControl = node.ctrlName === "DsfHtml" || node.ctrlName === "DsfMobileHtml";
    const metadataFullCode = node.metadata_fullcode;
    let modelExpress = "$viewData";
    let s = [];
    slotScope && s.push(slotScope);
    scopeDataKey && s.push(scopeDataKey);
    if (s.length) {
      modelExpress = s.join(".");
    }
    // let modelExpress = (isRepeat) ? (slotScope ? slotScope + (scopeDataKey ? "." + scopeDataKey : "") : "") : "$viewData"
    let attachAttrs = {};
    if (isFormControl && metadataFullCode) {
      attachAttrs["v-model"] = modelExpress + "['" + metadataFullCode + "']";
      //如果是枚举型组件，并且不是预览模式，则绑定items属性
      const nodeMd = node.metadata;
      const isEnumControl = nodeMd.ckey == "items-meta-data" || nodeMd.dataSourceWatch;
      if (isEnumControl && !isPreView) {
        attachAttrs[":items"] = "$enum['" + metadataFullCode + "']";
      }
    }
    if (node.treeProxy) {
      _.each(node.slots, (s, i) => {
        if (s.controls.length > 0) {
          _.each(s.controls, (c, ii) => {
            let child = createElement(
              c,
              parent,
              { slotName: s.name, slotIndex: i, $index: ii },
              slotScope,
              scopeDataKey,
              isRepeat,
              prefix,
              textProxy
            );
            arr.push(...child.tpl);
            dsf.mix(props, child.props);
          });
        }
      });
    }
    //如果是html组件，并且不是预览模式，则将组件内容追加到模板
    else if (isHTMLControl) {
      if (!isPreView && hasExtJs) {
        hasComment && arr.push("<!--html组件生成内容-->");
        if (node.html) {
          arr.push(dsf.unescapeHTML(node.html));
        }
      }
    } else {
      let hasShowLogicOption = false;
      if (parent) {
        if (showLogicOptions) {
          let rule = showLogicOptions[node.designId];
          if (
            rule &&
            ((rule.mode == "options" && rule.options.length) ||
              (rule.mode == "advanced" && rule.advanced))
          ) {
            hasShowLogicOption = true;
          }
        } else if (showLogicCompile?.[node.designId]) {
          hasShowLogicOption = true;
        }
      }
      if (hasShowLogicOption) {
        let params = `'${node.designId}'`;
        if (slotScope) {
          params += `, ${slotScope}`;
        }
        arr.push(`<template v-if="$showLogic(${params})">`);
      }
      let ref = "";
      if (!isRepeat) {
        attachAttrs["v-bind.sync"] = "$controls['" + node.designId + "']";
        if (node.caption) {
          ref = "'" + node.caption + "'";
        }
      } else {
        controlHash = `${modelExpress}.${"$hash"}`;
        attachAttrs["v-bind.sync"] = `$controls['${node.designId}-'+${controlHash}]`;
      }
      attachAttrs[":local"] = modelExpress;
      attachAttrs[":design-id"] = "'" + node.designId + "'";
      attachAttrs[":key"] = "'" + node.designId + "'";
      if (node.isOnce) {
        attachAttrs["v-once"] = "";
      }
      if (ref) {
        attachAttrs[":ref"] = ref;
        attachAttrs[":ctrl-id"] = ref;
      }
      if (node.isView) {
        if (node.loadPrecedence == "data") {
          attachAttrs["v-if"] = "$isLoaded";
        }
        if (node.ctrlType.startsWith("dsf.mobile.")) {
          attachAttrs["v-mobile-loading"] = "loading";
        } else {
          attachAttrs["v-loading.fullscreen"] = "loading";
        }
      }
      let attrMap = getVuePropsAndEventMap(attachAttrs);
      //如果不是预览模式并且正常加载extjs的情况下则绑定自定义属性
      let customAttrs = {};
      if (!isPreView && hasExtJs) {
        customAttrs = getVuePropsAndEventMap(node?.development?.["attrs"] || {}) || {};
      }
      let mergeAttrs = { ...attrMap, ...customAttrs };
      let _textProxy = node.textProxy;
      if (_textProxy) {
        hasComment && arr.push("<!--" + (node.label || node.caption) + "-->");
        // arr.push(`<template>`);
        // let exp = `${modelExpress+ "['" + metadataFullCode + "']"}`;
        let ctrl = "$controls['" + node.designId + "']";
        let attrsArr = _.map(mergeAttrs, (attr) => {
          let name = attr.prefix + attr.propName + attr.modifier;
          if (
            (attr.prefix == "v-bind" && attr.propName == "") ||
            (attr.prefix == "" && attr.propName == "v-bind")
          ) {
            return `${"v-bind"}="${ctrl}"`;
          } else if (attr.propName == "ref") {
            return "";
          } else if (dsf.isUnDef(attr.value)) {
            return name;
          } else {
            return `${name}=${attr.value}`;
          }
        });
        arr.push(`<DsfTextProxy ${attrsArr.join(" ")}></DsfTextProxy>`);
        props[node.designId] = node;
      } else {
        let attrsArr = _.map(mergeAttrs, (attr) => {
          let name = attr.prefix + attr.propName + attr.modifier;
          if (attr.value) {
            return name + "=" + attr.value;
          } else {
            return name;
          }
        });
        hasComment && arr.push("<!--" + (node.label || node.caption) + "-->");
        let tagName = node.ctrlName;
        let isUseRepeatProxy = false;
        if (isRepeat) {
          let mark = mergeAttrs?.["v-bind"]?.value || "";
          if (mark.startsWith('"$controls[')) {
            isUseRepeatProxy = true;
            let vIfExpress = mergeAttrs?.["v-if"] ? `v-if=${mergeAttrs["v-if"].value}` : "";
            arr.push(
              `<DsfRepeatProxy ${vIfExpress} :design-id="'${
                node.designId
              }'" :hash="${modelExpress}.${"$hash"}">`
            );
          }
        }
        let defer = node.defer;
        let allowDefer = false;
        if (defer && defer !== "inited") {
          allowDefer = true;
        }
        if (allowDefer && node.isView && node.designProxy) {
          allowDefer = false;
        }
        if (allowDefer) {
          arr.push(`<template v-if="$defer('${node.defer}')">`);
        }
        tagName && arr.push("<" + tagName + " " + attrsArr.join(" ") + ">");
        // arr.push("<" + node.ctrlName + " " + attrsArr.join(" ") + ">");
        if (node.development["slots"] && !isPreView) {
          arr.push(node.development["slots"]);
        }
        _.each(node.slots, (s, i) => {
          if (s.controls.length > 0) {
            let templateMark = true;
            // if (s.name == "default" && !s.scope) {
            //   templateMark = false;
            // }
            if (templateMark) {
              //添加插槽内容
              arr.push(
                "<template #" + s.name + (s.scope ? "=" + JSON.stringify(s.scope) : "") + ">"
              );
            }
            let repeat = s.repeat === true ? true : false;
            if (isRepeat) {
              repeat = true;
            }
            let prefix = s.repeat === true ? node.caption : "";
            let dataKey = s.dataKey || scopeDataKey;
            let scopeName = s.scope || slotScope;
            let textProxy = s.textProxy;
            _.each(s.controls, (c, ii) => {
              let child = createElement(
                c,
                node,
                { slotName: s.name, slotIndex: i, $index: ii },
                scopeName,
                dataKey,
                repeat,
                prefix,
                textProxy
              );
              arr.push(...child.tpl);
              dsf.mix(props, child.props);
            });
            if (templateMark) {
              arr.push("</template>");
            }
          }
        });
        tagName && arr.push("</" + tagName + ">");
        if (allowDefer) {
          arr.push("</template>");
        }
        if (isUseRepeatProxy) {
          arr.push("</DsfRepeatProxy>");
        }
        props[node.designId] = node;
      }
      if (hasShowLogicOption) {
        arr.push(`</template>`);
      }
    }

    defaultOptions.after && defaultOptions.after(node, parentNodes, slot, slotScope, scopeDataKey);
    parentNodes.pop();
    return {
      props: props,
      tpl: arr
    };
  }
  let result = createElement(layout, null);
  return {
    props: result.props,
    tpl: result.tpl.join("\n")
  };
}

let vueProp_rexp = /^:|^\.|^v-bind:/;
let vueEvent_rexp = /^@|^v-on:/;
function getVuePropsAndEventMap(props) {
  let attrMap = {};
  _.each(props, (s, i) => {
    // let attr = attachAttrs[i];
    var propExpressArray = i.split(".");
    let propName = "",
      prefix = "",
      modifier = "",
      value = "";
    let single = ["v-once"];
    let index = single.indexOf(i);
    if (index >= 0) {
      propName = single[index];
      prefix = "";
      modifier = "";
      value = undefined;
    } else {
      // if(i.indexOf(""))
      vueProp_rexp.lastIndex = 0;
      vueEvent_rexp.lastIndex = 0;
      if (vueProp_rexp.test(i)) {
        //属性
        let rexp_prop = /^(:|v-bind:?)?([^\.:)]*)(\..+)?/g;
        let group = rexp_prop.exec(i);
        if (group && group.length > 1) {
          propName = group[2];
          prefix = group[1];
          modifier = group[3];
        }
      } else if (vueEvent_rexp.test(i)) {
        //事件
        let rexp_event = /^(@|v-on:?)?([^\.)]*)(\..+)?/g;
        let group = rexp_event.exec(i);
        if (group && group.length > 1) {
          propName = group[2];
          prefix = group[1];
          modifier = group[3];
        }
      } else {
        //其他类型（指令，过滤器等其他属性）
        let rexp_other = /([^\.]+)(\.[^\.]+)?/g;
        let group = rexp_other.exec(i);
        if (group && group.length > 1) {
          propName = group?.[1] || "";
          prefix = "";
          modifier = group?.[2] || "";
        }
      }

      if (
        dsf.type(s) != "string" &&
        (propExpressArray[0].startsWith(":") || propExpressArray[0].startsWith("v-bind:"))
      ) {
        s = "" + s;
      }
      value = JSON.stringify(s);
    }
    let attr = {
      propName: propName || "",
      prefix: prefix || "",
      modifier: modifier || "",
      value: value
    };
    attrMap[propName || prefix] = attr;
  });
  return attrMap;
}

function convertControlData(layout) {
  layout = dsf.mix(true, {}, layout);
  let props = {};
  dsf.recursionComponentProps(layout, (it) => {
    props[it.designId] = it;
  });
  return {
    props: props
  };
}

// function getTableSlot(ctrl) {
//   let columnEl = ctrl.$el.closest("[column-id]");
//   if (columnEl) {
//     return columnEl.getAttribute("column-id") || "";
//   }
//   return "";
// }

//编译scss
function compileCss(scssStr, nameSpace) {
  return loader().then((res) => {
    let module = dsf.getEsModule(res);
    return module.compileCss(scssStr, nameSpace);
  });
}

//创建元数据，如果是表单模式则校验元数据是否同源并提示
/**
 *
 * @param {*} page 页面实例
 * @param {*} mobile 是否是移动端
 * @param {*} designer 设计器实例
 * @param {*} metadataDifferentSources 表示保存时候是否要校验元数据是否同源
 * @returns
 */
//metadataDifferentSources表示
function createAndCheckMetaDataSource(page, mobile, designer, metadataDifferentSources) {
  return loader().then((res) => {
    let module = dsf.getEsModule(res);
    return module.createAndCheckMetaDataSource(page, mobile, designer, metadataDifferentSources);
  });
}

//自动保存布局
function autoSaveLayout(designer) {
  return loader().then((res) => {
    let module = dsf.getEsModule(res);
    return module.autoSaveLayout(designer);
  });
}

//保存布局
function saveLayout(designer) {
  return loader().then((res) => {
    let module = dsf.getEsModule(res);
    return module.saveLayout(designer);
  });
}
//自定义提交布局函数
function customPostLayout(designer, customFn) {
  return loader().then((res) => {
    let module = dsf.getEsModule(res);
    return module.customPostLayout(designer, customFn);
  });
}

function compileFormulaCode(page) {
  return loader().then((res) => {
    let module = dsf.getEsModule(res);
    return module.compileFormulaCode(page);
  });
}

//保存模板
function saveLayoutToTemplate(designer) {
  return loader().then((res) => {
    let module = dsf.getEsModule(res);
    return module.saveLayoutToTemplate(designer);
  });
}

//获取页面提交的布局的接口参数
function getPostLayoutParams(designer, page, md, isPreview = false, callback) {
  return loader().then((res) => {
    let module = dsf.getEsModule(res);
    return module.getPostLayoutParams(designer, page, md, isPreview, callback);
  });
}

//提交布局信息
function postLayoutInfo(designer, page, md, api, callback) {
  return loader().then((res) => {
    let module = dsf.getEsModule(res);
    return module.postLayoutInfo(designer, page, md, api, callback);
  });
}

//保存到业务组件组
function saveToBusinessComponentGroup(designer, controlList) {
  return loader().then((res) => {
    let module = dsf.getEsModule(res);
    return module.saveToBusinessComponentGroup(designer, controlList);
  });
}

function isFormPage(page) {
  let t = "";
  if (page) {
    if (dsf.type(page) == "object") {
      t = page.pageType;
    } else {
      t = page;
    }
  }
  return postForm.indexOf(t) >= 0;
}

function isPrototypePage(page) {
  let t = "";
  if (page) {
    if (dsf.type(page) == "object") {
      t = page.mode;
    } else {
      t = page;
    }
  }
  return t === enums.viewMode.PROTOTYPE;
}

//获取组件属性的json配置
function getComponentPropries(designer, ctrlType, folder) {
  let defaultPath = `$/pd_attributes/${folder}/${ctrlType}.json`;
  if (designer.propertyJsonPath) {
    return designer.$http
      .get(`$/${designer.propertyJsonPath}/${folder}/${ctrlType}.json`)
      .catch(() => {
        return designer.$http.get(defaultPath);
      });
  } else {
    return designer.$http.get(defaultPath);
  }
}

function beginEditTextConent(target) {
  target = $(target);
  if (!target.hasClass("ds-text-content")) {
    target = target.children(".ds-text-content");
  }
  if (target) {
    setTimeout(() => {
      target?.focus?.();
      target?.select?.();
    }, 200);
  }
}

function triggerDialogPropty(prop) {
  let propel = $(".designer-props").find("[rel='" + prop + "']");
  propel.find(".ds-button")?.get?.(0)?.click?.();
}

const conditionType = {
  operation: { text: "运算", value: "operation" },
  follow: { text: "跟随", value: "follow" }
};

const operatorMap = {
  null: { text: "空", value: "null" },
  notnull: { text: "非空", value: "notnull" },
  like: { text: "模糊匹配", value: "like" },
  slike: { text: "开头匹配", value: "slike" },
  elike: { text: "结尾匹配", value: "elike" },
  eq: { text: "等于", value: "eq" },
  noteq: { text: "不等于", value: "noteq" },
  gt: { text: "大于", value: "gt" },
  gteq: { text: "大于等于", value: "gteq" },
  lt: { text: "小于", value: "lt" },
  lteq: { text: "小于等于", value: "lteq" }
};

const comparisonOperatorOptions = {
  string: {
    null: operatorMap.null,
    notnull: operatorMap.notnull,
    eq: operatorMap.eq,
    noteq: operatorMap.noteq,
    like: operatorMap.like,
    slike: operatorMap.slike,
    elike: operatorMap.elike
  },
  date: {
    null: operatorMap.null,
    notnull: operatorMap.notnull,
    eq: operatorMap.eq,
    noteq: operatorMap.noteq,
    gt: operatorMap.gt,
    gteq: operatorMap.gteq,
    lt: operatorMap.lt,
    lteq: operatorMap.lteq
  },
  number: {
    null: operatorMap.null,
    notnull: operatorMap.notnull,
    eq: operatorMap.eq,
    noteq: operatorMap.noteq,
    gt: operatorMap.gt,
    gteq: operatorMap.gteq,
    lt: operatorMap.lt,
    lteq: operatorMap.lteq
  },
  object: {
    null: operatorMap.null,
    notnull: operatorMap.notnull
  },
  time: {
    null: operatorMap.null,
    notnull: operatorMap.notnull,
    eq: operatorMap.eq,
    noteq: operatorMap.noteq,
    gt: operatorMap.gt,
    gteq: operatorMap.gteq,
    lt: operatorMap.lt,
    lteq: operatorMap.lteq
  },
  longObject: {
    null: operatorMap.null,
    notnull: operatorMap.notnull
  }
};

const conditionValueType = {
  enum: { text: "选项", value: "enum" },
  custom: { text: "自定义", value: "custom" }
};

export default {
  getParentControl,
  isAllowDrop,
  controlToJson,
  broadcast,
  getStaticValue,
  getLayoutInfo,
  getDsfComponent,
  recursionLayoutTree,
  // createPinyinField,
  createViewMetaData,
  checkMetadataControlValue,
  createComponentMetaData,
  getComponentByTarget,
  createComponent,
  createMobileComponent,
  convertTemplateAndControlData,
  convertControlData,
  saveLayoutValidate,
  saveToBusinessComponentGroup,
  compileCss,
  validateCaption,
  getExtPath,
  getPageDocumet,
  getLayoutPath,
  saveLayout,
  autoSaveLayout,
  customPostLayout,
  saveLayoutToTemplate,
  compileFormulaCode,
  getPostLayoutParams,
  postLayoutInfo,
  isFormPage,
  isPrototypePage,
  getComponentPropries,
  getRealComponent,
  beginEditTextConent,
  triggerDialogPropty,
  analysisLayoutInfo,
  requestAsyncComponentsByLayout,
  getComponentCodeByClient,
  getDesignLayoutIncludeAndExclude,
  conditionType,
  comparisonOperatorOptions,
  conditionValueType
};
